import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import Modal from 'react-modal';
import * as yup from 'yup';

// material ui
import {
  Box,
  Button,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

// graphql
import { useCreateCashierCashTransferMutation, useCreateCashierCashWithdrawalMutation } from '@/generated/graphql';

// interfaces
import type { ICashierTable, IManagerCashierCashInput } from '@/shared/interfaces';

import { MdOutlinePostAdd } from 'react-icons/md';
import { useState } from 'react';

interface IUsherProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  cashiers: ICashierTable[];
  setRefetchCashierCashQuery: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ModalManageCash = ({ open, setOpen, cashiers, setRefetchCashierCashQuery }: IUsherProps) => {
  const handleClose = () => setOpen(false);

  const { reset, handleSubmit, control } = useForm<IManagerCashierCashInput>({
    mode: 'onChange',
    defaultValues: {
      amount: '',
      cashierId: '',
      type: 'transfer',
    },
  });

  const [createCashierCashTransfer] = useCreateCashierCashTransferMutation();
  const [createCashierCashWithdrawal] = useCreateCashierCashWithdrawalMutation();

  const onSubmit = async (dataInput: IManagerCashierCashInput) => {
    const { amount, cashierId, type } = dataInput;

    if (type === 'transfer') {
      const { data } = await createCashierCashTransfer({
        variables: { input: { cashierId, amount: parseInt(amount.toString()) } },
      });
      console.log(data, '--');
    } else if (type === 'withdrawal') {
      const { data } = await createCashierCashWithdrawal({
        variables: { input: { cashierId, amount: parseInt(amount.toString()) } },
      });
    }

    // const { data } = await createReportTypeMutation({
    //   variables: {
    //     input,
    //   },
    // });

    // if (data) console.log(data);
    // if (errors) console.log(errors);
    setRefetchCashierCashQuery(true);
    handleClose();
    reset();
  };

  return (
    <>
      <Modal
        isOpen={open}
        onRequestClose={handleClose}
        style={{
          overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            color: 'inherit',
            backgroundColor: 'rgba(25, 25, 25, 0.75)',
          },
          content: {
            width: '400px',
            overflow: 'unset',
            position: 'absolute',
            margin: '0.1% auto',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            padding: 0,
            marginRight: '-50%',
            transform: 'translate(-50%, -48vh)',
            border: '0px',
            background: 'transparent',
            WebkitOverflowScrolling: 'touch',
            borderRadius: '4px',
            outline: 'none',
          },
        }}>
        <Box
          sx={{
            backgroundColor: '#fff',
            overflow: 'unset',
            borderRadius: '5px',
          }}
          mt={9}>
          <Box sx={{ px: 5, py: 2 }} alignItems={'center'}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography gutterBottom variant="subtitle2" m={0}>
                Add or Deduct Cashier Cash
              </Typography>
              <MdOutlinePostAdd fontSize={18} />
            </Stack>
          </Box>
          <Divider />

          <Box px={5} pt={2} pb={2}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid>
                <Controller
                  name="amount"
                  control={control}
                  rules={{
                    required: 'Amount is required',
                    min: { value: 1, message: 'Must be at least 1' },
                    pattern: { value: /^[0-9]*$/, message: 'Must be a number' },
                  }}
                  render={({ field, fieldState }) => (
                    <TextField
                      {...field}
                      label="Amount"
                      type="number"
                      variant="standard"
                      fullWidth
                      error={!!fieldState.error}
                      helperText={fieldState.error ? fieldState.error.message : null}
                      slotProps={{ inputLabel: { shrink: true } }}
                      sx={{ mt: 5 }}
                    />
                  )}
                />

                <Controller
                  name="cashierId"
                  control={control}
                  rules={{ required: 'Cashier is required' }}
                  render={({ field, fieldState }) => (
                    <FormControl fullWidth error={!!fieldState.error} size="small" sx={{ mt: 3 }}>
                      <InputLabel id="cashierId-select-label">Cashier</InputLabel>
                      <Select
                        {...field} // Spread field props
                        labelId="cashierId-select-label"
                        id="cashierId-select"
                        label="cashier" // This is important for the outline and label animation
                      >
                        {cashiers.map((option) => (
                          <MenuItem key={option.id} value={option.id}>
                            {option.name}
                          </MenuItem>
                        ))}
                      </Select>
                      {fieldState.error && <FormHelperText>{fieldState.error.message}</FormHelperText>}
                    </FormControl>
                  )}
                />

                <Controller
                  name="type"
                  control={control}
                  rules={{ required: 'Type is required' }}
                  render={({ field, fieldState }) => (
                    <FormControl component="fieldset" error={!!fieldState.error} fullWidth sx={{ mt: 3 }}>
                      <FormLabel component="legend">Type</FormLabel>
                      <RadioGroup
                        {...field} // Spread field props (value, onChange, onBlur, ref)
                        row // Display radio buttons in a row
                        aria-labelledby="preferred-contact-radiogroup-label" // Good for accessibility
                      >
                        <FormControlLabel value="transfer" control={<Radio />} label="Transfer" />
                        <FormControlLabel value="withdrawal" control={<Radio />} label="Withdrawal" />
                      </RadioGroup>
                      {fieldState.error && <FormHelperText>{fieldState.error.message}</FormHelperText>}
                    </FormControl>
                  )}
                />
              </Grid>
              <Grid container justifyContent={'end'} mt={5}>
                <Button
                  type="submit"
                  size="small"
                  variant="contained"
                  sx={{
                    background: 'grey',
                    fontSize: 10,
                    fontWeight: 600,
                    paddingLeft: '20px',
                    paddingRight: '20px',
                    textTransform: 'unset',
                  }}
                  onClick={handleClose}>
                  Cancel
                </Button>
                <Button
                  sx={{
                    ml: 1,
                    fontSize: 10,
                    fontWeight: 600,
                    paddingLeft: '20px',
                    paddingRight: '20px',
                    paddingTop: '8px',
                    paddingBottom: '8px',
                    textTransform: 'unset',
                  }}
                  type="submit"
                  size="small"
                  variant="contained">
                  Create
                </Button>
              </Grid>
            </form>
          </Box>
        </Box>
      </Modal>
    </>
  );
};
